export const he = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'הוסף טקסט',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'הוסף לעגלה',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'יישור התחתונה',
  ALIGN_CENTER_KEY: 'יישר למרכז',
  ALIGN_KEY: 'ישר',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'ליישר באמצע',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'יישר למעלה',
  ALL_TAB_TITLE_KEY: 'הכל',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'רקע',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'לא נמצא השראה בקטגוריה זו',
  BRING_TO_FRONT_KEY: 'העבר קדימה',
  CANCEL_TEXT_KEY: ' ביטול',
  CENTIMETERS_KEY: 'סנטימטרים',
  CM_KEY: 'ס"מ.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'בחר קובץ',
  CITY: 'City',
  CLEAR_ALL_KEY: 'נקה הכל',
  CLEAR_COLOR_KEY: 'נקה צבע',
  CLOSE_WINDOW_KEY: 'סגור חלון',
  CLEAR_ALL_OBJECTS: 'נקה את כל האובייקטים',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: 'פעולה זו תסיר את כל האובייקטים מהרקע.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'צבע',
  CONTINUE_KEY: 'המשך...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'ס"מ',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'עיצוב',
  DELETE_KEY: 'מחיקה',
  DOCUMENT_COLORS: 'צבעי מסמך',
  DONE: 'Done!',
  DONE_KEY: 'סיום',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'הורד',
  DOWNLOAD_APP_TITLE_KEY: 'תוכל להוריד את האפליקציה כאן:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'ייבוא אל Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'חיפוש Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'תמונות Dreamstime',
  DUPLICATE_KEY: 'שכפול',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Edit Design',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: 'מצטערים, אירעה שגיאה. נסה שוב מאוחר יותר.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    ' אופס, אירעה שגיאה בעת פתיחת קובץ ה-PDF שהועלה.',
  EMAIL_KEY: 'דוא"ל',
  EMAIL_ADDRESS_KEY: 'כתובת דוא"ל:',
  EMAIL_CHECKBOX_MESSAGE:
    'למיטב ידיעתי אדם זה מבין שהוא יקבל הודעות דוא"ל מ-‏HP‏ בשמי או בשם ספק השירות.',
  EXTRA_INFO_KEY: 'מידע נוסף',
  EMAIL_NOTIFICATION: 'הודעת דוא&quot;ל תישלח בקרוב. העיבוד יימשך כ-15 דקות.',
  EMAIL_DIALOG_MESSAGE:
    'הקלד את כתובת הדוא"ל האלקטרוני של האדם שאיתו ברצונך לשתף את העיצוב.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'תיקייה קיימת',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'ודא שכל הפריטים שנבחרו תקינים לפני שתמשיך לשלב התשלום',
  FINAL_CHECK_TITLE_KEY: 'בדיקה סופית',
  FINISH_KEY: 'סיום',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'הפוך',
  FOR_KEY: 'ל',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'מילות מפתח:',
  FOLDER_NAME: 'שם תיקייה',
  FOLDER_NAME_KEY: 'שם תיקייה:',
  FOLDER_ALREADY_EXIST_KEY: 'שם תיקייה זה כבר קיים',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'קבץ הכל',
  GROUP_SCALE: 'קבץ שינוי קנה מידה',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'תן שם לפרוייקט',
  HEIGHT_KEY: 'גובה',
  HELP_DESCRIPTION_KEY:
    'Let us walk you through the design process. Remember you can open the tour as many times as you want by clicking on the help icon.',
  HELP_KEY: 'עזרה',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'תמונות',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'מייבא',
  INCHES_COLUMN_HEADER_KEY: "אינצ'ים",
  INCHES_KEY: " אינץ'",
  INCHES_UNIT_STRING_KEY: "אינץ'.",
  INVALID_EMAIL_ADDRESS_KEY: 'כתובת דוא"ל לא חוקית',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'שם לא חוקי',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'מצטערים, הקובץ שבחרת גדול מדי. גודל הקובץ המרבי הוא 500mb.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'אופס, זו אינה תבנית קובץ חוקית. באפשרותנו לטפל בתבניות pdf, jpg, png, svg, ו-tif בלבד.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'שפה',
  LASTNAME: 'Last name',
  LEARN_MORE: 'מידע נוסף',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY: 'על-ידי שימוש באתר זה אתה מסכים ל',
  LEGAL_FOOTER_MESSAGE2_KEY: 'אתר אינטרנט זה תואם ל',
  LEGAL_FOOTER_MESSAGE3_KEY: 'וכן',
  LENGTH_STRING_IN_INCHES_KEY: "אינץ'",
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'להצגה חזותית של התוכן שאתה מוסיף, אנא הורד את אפליקציית LinkReader.',
  LOADING_KEY: 'טוען...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'נעילה',
  LOGIN_KEY: 'כניסה',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'התחברות ל Dreamstime',
  LOGOUT_KEY: 'יציאה',
  MATERIAL_TITLE_KEY: 'חומר',
  MATERIAL_STRING_KEY: 'חומר',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'לא ניתן לבצע הקטנה נוספת של רקע זה מכיוון שהגעת לגובה או לרוחב המינימליים הדרושים לכיסוי הקיר.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'דגם',
  MORE_INFO_TEXT_KEY: 'מידע נוסף',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'שם:',
  NEXT_BUTTON_TITLE_KEY: 'הבא',
  NEW_FOLDER_KEY: 'תיקייה חדשה',
  NO_SHADOW_KEY: 'ללא צל',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'אישור',
  ORDER_SAMPLE_KEY: 'הזמנת דוגמה',
  ORDER_SAMPLE: 'הזמן דוגמה',
  ORDER_SAMPLE_INFOLABEL_1: 'בחר את החלק מהתמונה שברצונך להזמין בתור דוגמה',
  ORDER_SAMPLE_INFOLABEL_2:
    'תקבל דואר אלקטרוני עם תצוגת תקריב של הפרוייקטים שלך בגודל אמיתי',
  ORDER_SAMPLE_INFOLABEL_3:
    'תצוגת התקריב תאפשר לך להעריך את האיכות והרזולוציה של התמונה',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'הזמן דוגמה כעת',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'קבל הודעת דוא"ל המכילה תצוגת תקריב של הפרוייקט בגודל ממשי כדי לבצע הערכת איכות/רזולוציה לפרוייקט.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'סיסמה',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'אני מחזיק בזכויות היוצרים על תמונה זו ואני מסכים ל',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'פיקסל',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'ס"מ',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'כלומר מספר דברים חשובים שבהם חשוב שתיידע את חנות ההדפסה',
  PLACEHOLDER_INCHES_STRING_KEY: "אינץ'",
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'מיקום',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'שמור את הפרוייקט',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'הפרוייקט שלך כולל שינויים שיש לשמור לפני שתמשיך.',
  PRICE_COLUMN_HEADER_KEY: 'מחיר',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'מעבד...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'תצוגה מקדימה',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'שם הפרוייקט',
  PROJECT_NAME: 'שם הפרוייקט:',
  PROJECT_ALREADY_EXIST_KEY: 'שם פרוייקט זה כבר קיים',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'שם פרוייקט זה כבר קיים',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'שם תיקייה זה כבר קיים',
  PIXELATION_WARNING_KEY: 'אזהרה בנוגע לחלוקה לפיקסלים',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'בשל הרזולוציה של התמונה שהעלית, עורך עלול להיות מעוות או מעוות. כדי להבטיח שאין טשטוש, אנא העלה תמונה באיכות טובה והימנע ממתיחת תמונות. אם אתה מרוצה מהתצוגה המקדימה וברצונך להמשיך, אנא המשך להגיש.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'נדרש',
  RECOLOR_KEY: 'צבע מחדש',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'צבע מחדש',
  REQUEST_SAMPLE_KEY: 'בקש דגימה',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'בקשה להצעת מחיר',
  RIGHT_LOGO_TEXT_KEY: 'של',
  ROTATE_KEY: 'סובב',
  ROTATE_LEFT_KEY: 'סובב 90° שמאלה',
  ROTATE_RIGHT_KEY: 'סובב 90° ימינה',
  ROTATION_KEY: 'סיבוב',
  ROWS_COLUMN_LABEL_STRING_KEY: 'שורות ועמודות',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'שמור',
  SAVING_KEY: 'שומר...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'שמור את הפרוייקט',
  SAVE_PROJECT_NAME_KEY: 'שמור את הפרוייקט תחילה',
  SAVEDIALOG_MESSAGE:
    'היכנס כדי לשמור את הפרוייקט.אם טרם יצרת חשבון, נעזור לך ליצור אותו. העבודה שביצעת בפרוייקט תישמר.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'שינוי קנה מידה',
  SCALE_ALL_KEY: 'שינוי קנה מידה של כל הפריטים',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'חיפוש',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'חיפוש',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'שלח לי הוראות התקנה',
  SEND_TO_BACK_KEY: 'העבר לאחור',
  SEND_KEY: 'שלח',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'הגדרת גודל',
  SETTINGS_KEY: 'הגדרות',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'שיתוף',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'רגל רבועה',
  SQM_UNIT_STRING_KEY: 'מטר רבוע',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'שלח',
  SHARE_LINK_LABEL: 'בחר את סוג הקישור שברצונך לשתף',
  SHARE_EDIT_LINK: 'ערוך קישור',
  SHARE_VIEW_LINK: 'הצג קישור',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT: '* ניתן לשנות את מרחק הצפייה ביעד באמצעות הגדרות.',
  TERMS1_KEY: 'תנאים',
  TERMS2_KEY: 'הצהרת הפרטיות של HP‏',
  TERMS3_KEY: 'הודעה של HP בנוגע לזכויות על נתונים אישיים',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'תנאי שימוש.',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'אריח',
  TOTAL_KEY: 'סה"כ',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'תודה',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'בטל נעילה',
  UNGROUP_KEY: 'פרק קבוצה',
  UPDATE_TEXT_KEY: 'עדכון',
  UPLOAD_KEY: 'העלאת תמונה',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'שם משתמש',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'בטל פרישה',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'תוקף',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'מע"מ',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'הצג ב-Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'הצג פרטי מעצב',
  VIEW_DESIGNER_PROFILE_KEY: 'הצג פרופיל מעצב',
  VIEW_PRICE_KEY: 'הצג מחיר',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'פוסטר לקיר',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'אזהרה',
  WEBSITE: 'Website',
  WIDTH_KEY: 'רוחב',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'השם שלך',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'הפרוייקט שלך:',
  PROJECT_NAME_ERROR_TEXT: 'הזן שם עבור הפרוייקט.',
  PROJECT_FOLDER_ERROR_TEXT: 'הזן שם עבור תיקיית הפרוייקט.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'מרחק צפייה מינימלי',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'לא נמצא תוכן',
  NO_ELEMENT_ERROR_MESSAGE: 'רכיב לא נמצא.',
  NO_MORE_IMAGES_FOUND_KEY: 'לא נמצאו תמונות נוספות',
  NO_PATTERN_ERROR_MESSAGE: 'לא נמצאו תבניות.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'הודעה:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design.{0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'בעקבות שינוי קנה המידה שביצעת, התמונה המודפסת עשויה להיראות מפוקסלת בעת הצגתה ב-{0} {1} *(רזולוציית ההדפסה הנוכחית היא {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'מרחק הצפייה המומלץ אמור להיות {0} {1}. אם הדבר אינו אפשרי, הקטן את התמונה או את ה-קיר.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    '{0} גודל תמונה מינימלי מומלץ הוא x {1} פיקסלים.',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'הממדים המינימליים הם {0} (רוחב) על {1} (גובה).',
  MINIMUM_HEIGHT_KEY: '{0} הגובה המינימלי הוא.',
  MINIMUM_WIDTH_KEY: '{0} הרוחב המינימלי הוא.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: '{0} הרוחב המקסימלי הוא.',
  MAXIMUM_HEIGHT_KEY: '{0} הגובה המקסימלי הוא.',
  INVALID_NUMBER_ERROR_TEXT_KEY: '.הזן ממדים מספריים מעל אפס',
  PROCESSING_FAILED: 'העיבוד נכשל, נסה שוב לאחר זמן מה',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: 'מצטערים, קובצי PDF מוצפנים אינם נתמכים.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'מייבא קובץ {0} מתוך {1}',
  RECOLORING_KEY: 'צובע מחדש...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'מקור תוכן זה מוגן על-ידי סיסמה',
  AUTHENTICATE_FAILED_MESSAGE: 'אימות נכשל!',
  DROPBOX_IMPORT_ERROR_HEADER: 'אירעה בעיה בייבוא חלק מהקבצים',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'מצטערים, מסמכי PDF מרובי-עמודים אינם נתמכים.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'תבנית ההשראה הזו מגיעה עם גודל ברירת מחדל של {0} X {1} {2}. גודל הדף שלך ישונה באופן אוטומטי כך שיתאים לתבנית זו.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'הזן שדות חובה',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'הפרטים שלך',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'הודעה:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'לקבלת עור למחשב המותאם באופן מושלם לשלך, עליך לבחור את הדגם המדויק המתאים לרכישה, כפי שהוא נראה בחשבונית.',
  RESTART_PROJECT_ALERT_TITLE: 'Restart a project ?',
  DISCARD_ALERT_MESSAGE: 'Your current project will be discarded',
  RESTART: 'Restart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'אזהרת גודל עמוד!',
  MODIFY_SIZE_WARNING:
    'אם ברצונך לשנות את גודל העיצוב הזה, תוכל לעשות זאת בכרטיסייה "הגדרות". אלמנטים עיצוביים עשויים לדרוש עריכה כדי להתאים למידות הרצויות.',
  RANDOMIZE_KEY: 'אקראי',
  MATERIAL_CHOICE_APPLIED: 'בחירת חומרים מיושמת.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: "בלוקצ'ין",
  CERTIFICATE_STRING: 'תעודת',
  AUTHENTICITY_STRING: 'אותנטיות',
  PLEASE_WAIT: 'המתן בבקשה',
  PROTECTING_YOUR_DATA: 'הגנה על הנתונים שלך...',
  SEARCH_YOUR_LAPTOP_KEY: 'חפש במחשב הנייד שלך', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'אופס! לא הצלחנו למצוא מחשבים ניידים לחיפוש שלך.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'מספר סידורי',
  LOCKED_PROJECT: 'פרוייקט נעול',
  LOCKED_MESSAGE:
    'פרוייקט זה הוזמן ולא ניתן לשנותו. באפשרותך להציג פרוייקט זה בלבד.',
  EXPIRED_PROJECT: 'פרוייקט שפג תוקפו',
  EXPIRED_MESSAGE: 'פג תוקפו של פרוייקט זה.',
  DELETED_PROJECT: 'פרוייקט שנמחק',
  DELETED_MESSAGE: 'פרוייקט זה נמחק.',
  CHOOSE_GROUP_TYPE: 'בחר סוג {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'הזן מספרים מעל אפס.',
  SIZE_KEY: 'גודל',
  DISTANCE_FROM_KEY: 'מרחק מ',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'שמאל',
  RIGHT_KEY: 'ימין',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'גודל הקיר המקסימלי הוא {0}sq.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'גובה הבד חורג מגובה הקיר.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'רוחב הבד חורג מגובה הקיר.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'מספר העמודות המרבי עבור הרוחב הנוכחי הוא {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: 'מספר השורות המרבי עבור הגובה הנוכחי הוא {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'רוחב הקיר קטן מרוחב הבד.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: 'רוחב הקיר המינימלי חייב להיות {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: 'גובה הקיר המינימלי חייב להיות {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'גובה הקיר נמוך מגובה הבד.',
  MAXIMUM_WALL_HEIGHT_KEY: 'גובה הקיר המקסימלי הוא {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'שורות',
  COLUMNS_KEY: 'עמודות',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'עריכה',
  TOP_KEY: 'חלק עליון',
  BOTTOM_KEY: 'חלק תחתון'
};
